import { Link } from "react-router-dom";
import { CopyrightNotice } from "@/components/legal/CopyrightNotice";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-20 border-t border-white/10 bg-black/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8">
          <div className="max-w-md">
            <div className="flex items-center gap-2">
              <img
                src="/logo.png"
                alt="VISMARKS logo"
                data-testid="footer-logo-img"
                className="h-7 w-7 rounded-md border border-[#FF3B30]/30 object-cover"
              />
              <span className="font-black tracking-tight text-white">VISMARKS</span>
            </div>
            <p className="mt-3 text-xs text-neutral-500 leading-relaxed" data-testid="footer-disclaimer-text">
              Vismarks is a product visibility engine. We do not guarantee sales volumes, revenue, or
              results. Sellers handle all shipping, fulfilment, and returns.
            </p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-neutral-400">
            <Link to="/discover" className="hover:text-white" data-testid="footer-discover-link">Discover</Link>
            <Link to="/open-demands" className="hover:text-white" data-testid="footer-open-demands-link">Buyer demand</Link>
            <Link to="/welcome" className="hover:text-white" data-testid="footer-welcome-link">Why VISMARKS</Link>
            <Link to="/launch" className="hover:text-white" data-testid="footer-launch-link">Launch</Link>
            <Link to="/referrals" className="hover:text-white" data-testid="footer-referrals-link">Refer &amp; earn</Link>
            <Link to="/buyer-protection" className="hover:text-white text-emerald-400" data-testid="footer-buyer-protection-link">Buyer Protection</Link>
            <Link to="/app" className="hover:text-white text-[#FF9F0A]" data-testid="footer-get-app-link">Get the app</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms</Link>
            <Link to="/seller-agreement" className="hover:text-white" data-testid="footer-seller-agreement-link">Seller Agreement</Link>
            <Link to="/stage-terms" className="hover:text-white" data-testid="footer-stage-terms-link">Stage &amp; Creator Terms</Link>
            <Link to="/refund-policy" className="hover:text-white" data-testid="footer-refund-policy-link">Refunds</Link>
            <Link to="/community-guidelines" className="hover:text-white" data-testid="footer-community-link">Community</Link>
            <Link to="/ip-policy" className="hover:text-white" data-testid="footer-ip-link">IP &amp; Counterfeits</Link>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/cookie-policy" className="hover:text-white" data-testid="footer-cookie-link">Cookies</Link>
            <Link to="/legal-center" className="hover:text-white text-[#FF9F0A]" data-testid="footer-legal-link">Legal Center</Link>
            <Link to="/account" className="hover:text-white" data-testid="footer-account-link">Privacy &amp; data</Link>
          </nav>
        </div>
        <div className="mt-8 pt-6 border-t border-white/5 space-y-2">
          <CopyrightNotice compact />
          <p className="text-[11px] text-neutral-600">No guarantee of sales — see our <Link to="/legal" className="underline hover:text-neutral-400">Legal Notice</Link>.</p>
        </div>
      </div>
    </footer>
  );
}
